(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cordaroysInstallmentsInit) return;
    window.__cordaroysInstallmentsInit = true;

    const LOADED_ATTR = 'data-terms-loaded';
    const PENDING_ATTR = 'data-terms-pending';
    const OBSERVED_FLAG = 'cordaroysInstallmentsObserved';
    const PENDING_FALLBACK_DELAY = 1800;
    const TERMS_LIFECYCLE_EVENTS = ['shopify:payment-terms:loaded', 'shopify:payment-terms:rendered'];
    const PLACEHOLDER_DATA_KEY = 'installmentsPlaceholderHeight';

    const getContainer = (termsEl) => termsEl?.closest?.('.installments') ?? null;
    const getPlaceholder = (container) => container?.querySelector?.('.installments__placeholder') ?? null;

    const ensurePlaceholderSeeded = (container) => {
      if (!container) return;
      const dataset = container.dataset;
      if (!dataset || dataset[PLACEHOLDER_DATA_KEY]) return;
      const inlineValue = container.style?.getPropertyValue('--installments-placeholder-height')?.trim();
      if (inlineValue) {
        dataset[PLACEHOLDER_DATA_KEY] = inlineValue;
        return;
      }
      const placeholder = getPlaceholder(container);
      const rect = placeholder?.getBoundingClientRect?.();
      if (rect && rect.height > 0) {
        dataset[PLACEHOLDER_DATA_KEY] = `${Math.ceil(rect.height)}px`;
      }
    };

    const applyStoredPlaceholderHeight = (container) => {
      if (!container) return;
      const storedValue = container.dataset?.[PLACEHOLDER_DATA_KEY];
      if (storedValue) {
        container.style.setProperty('--installments-placeholder-height', storedValue);
      }
    };

    const setPlaceholderHeight = (container, termsEl) => {
      if (!container || !termsEl) return;
      const rect = termsEl.getBoundingClientRect?.();
      if (rect && rect.height > 0) {
        const height = `${Math.ceil(rect.height)}px`;
        container.style.setProperty('--installments-placeholder-height', height);
        container.dataset[PLACEHOLDER_DATA_KEY] = height;
      }
    };

    const setPendingState = (container, isPending) => {
      if (!container) return;
      if (isPending) {
        applyStoredPlaceholderHeight(container);
        container.setAttribute(PENDING_ATTR, 'true');
      } else {
        container.removeAttribute(PENDING_ATTR);
      }
    };

    const schedulePendingFallback = (container) => {
      if (!container) return;
      window.setTimeout(() => {
        if (!container.isConnected) return;
        if (!container.querySelector('shopify-payment-terms')) {
          container.removeAttribute(LOADED_ATTR);
          setPendingState(container, false);
        }
      }, PENDING_FALLBACK_DELAY);
    };

    const markLoading = (termsEl) => {
      const container = getContainer(termsEl);
      if (!container) return;
      ensurePlaceholderSeeded(container);
      applyStoredPlaceholderHeight(container);
      container.removeAttribute(LOADED_ATTR);
      setPendingState(container, true);
      schedulePendingFallback(container);
    };

    const markLoaded = (termsEl) => {
      const container = getContainer(termsEl);
      if (!container) return;
      setPlaceholderHeight(container, termsEl);
      container.setAttribute(LOADED_ATTR, 'true');
      setPendingState(container, false);
    };

    const observeShadowContent = (termsEl) => {
      const root = termsEl.shadowRoot;
      if (!root) return;
      const observer = new MutationObserver(() => {
        const hasContent = root.innerHTML.trim() !== '';
        if (hasContent) {
          observer.disconnect();
          markLoaded(termsEl);
        } else {
          markLoading(termsEl);
        }
      });
      observer.observe(root, { childList: true, subtree: true });
    };

    const markWhenReady = (termsEl) => {
      if (!(termsEl instanceof HTMLElement)) return;
      if (termsEl.dataset[OBSERVED_FLAG] === 'true') return;
      termsEl.dataset[OBSERVED_FLAG] = 'true';

      markLoading(termsEl);

      const tryImmediate = () => {
        const root = termsEl.shadowRoot;
        if (root && root.innerHTML.trim() !== '') {
          markLoaded(termsEl);
          return true;
        }
        return false;
      };

      if (tryImmediate()) {
        return;
      }

      if (termsEl.shadowRoot) {
        observeShadowContent(termsEl);
      }

      let rafAttempts = 0;
      const maxAttempts = 10;
      const rafCheck = () => {
        if (tryImmediate()) {
          return;
        }
        rafAttempts += 1;
        if (rafAttempts < maxAttempts) {
          requestAnimationFrame(rafCheck);
        }
      };
      requestAnimationFrame(rafCheck);

      const onceLoaded = () => markLoaded(termsEl);
      TERMS_LIFECYCLE_EVENTS.forEach((eventName) => {
        termsEl.addEventListener(eventName, onceLoaded, { once: true });
      });

      window.setTimeout(() => {
        const root = termsEl.shadowRoot;
        if (root && root.innerHTML.trim() !== '') {
          markLoaded(termsEl);
        }
      }, 2000);
    };

    const processExisting = () => {
      document.querySelectorAll('shopify-payment-terms').forEach(markWhenReady);
    };

    const observeNewElements = () => {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;
            if (node.matches('shopify-payment-terms')) {
              markWhenReady(node);
            } else {
              node.querySelectorAll?.('shopify-payment-terms').forEach(markWhenReady);
            }
          });

          const container =
            mutation.target instanceof HTMLElement ? mutation.target.closest('.installments') : null;
          if (!container) continue;

          const removedHasTerms = Array.from(mutation.removedNodes).some(
            (removed) =>
              removed instanceof HTMLElement &&
              (removed.matches('shopify-payment-terms') || removed.querySelector?.('shopify-payment-terms'))
          );

          if (removedHasTerms) {
            container.removeAttribute(LOADED_ATTR);
            setPendingState(container, true);
            schedulePendingFallback(container);
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    const init = () => {
      const start = () => {
        const onLifecycleEvent = (event) => {
          const target = event.target;
          if (target instanceof HTMLElement && target.matches('shopify-payment-terms')) {
            markLoaded(target);
          }
        };

        TERMS_LIFECYCLE_EVENTS.forEach((eventName) => {
          document.addEventListener(eventName, onLifecycleEvent);
        });

        processExisting();
        observeNewElements();
      };

      if (customElements.get('shopify-payment-terms')) {
        start();
      } else {
        customElements.whenDefined('shopify-payment-terms').then(start);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
